import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { transitionAnimation, typographyBody1 } from './../../core';
import { NAVIGATION_WIDTHS } from '../constants';

const StyledNavigationContainer = styled.div`
  ${({ theme }) => typographyBody1(theme)};
  ${transitionAnimation('width')};
  background-color: ${({ theme }) => theme.color.gray[50].value};
  color: ${({ theme }) => theme.color.additional.dark.value};
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 0;
  position: ${({ isPositionStatic }) => (isPositionStatic ? 'static' : 'fixed')};
  top: 0;
  width: ${({ isCollapsed }) => (isCollapsed ? NAVIGATION_WIDTHS.COLLAPSED : NAVIGATION_WIDTHS.EXPANDED)};
  z-index: ${({ theme }) => theme.zIndex.globalNavigation.value};
`;

const NavigationContainer = forwardRef(({ isCollapsed = false, isPositionStatic = false, ...other }, ref) => (
  <StyledNavigationContainer isCollapsed={isCollapsed} isPositionStatic={isPositionStatic} ref={ref} {...other} />
));

NavigationContainer.propTypes = {
  /** If true, navigation is collapsed */
  isCollapsed: PropTypes.bool,
  /** If true, the navigation containers position will be 'fixed' to accommodate full page navigation container */
  isPositionStatic: PropTypes.bool,
};

export { NavigationContainer };
